import React, { Component } from "react"
import { Icon } from "antd"
// import { PRODUCT_URL } from "../constants/conf"
import Env from "../util/env"
import API from "../api/chanel"
import defaultLogo from "../img/logo-wayzi.png"
class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      logo: defaultLogo
      // channel: true,
      // logo:
      //   "https://wz-fs-lbs.s3.cn-northwest-1.amazonaws.com.cn/lbs_1555899643072f921af6a-869e-4664-91e6-1c2f149fd432.png",
    }
    this.getUserInfo()
  }
  getUserInfo = () => {
    if (!Env.getUser().potoken) {
      setTimeout(() => {
        this.getUserInfo()
      }, 50)
      return
    }
    API.customerInfo()
      .then(res => {
        if (res.logoPath) {
          this.setState({ logo: res.logoPath, channel: true, loaded: true })
        } else {
          this.setState({ loaded: true })
        }
      })
      .catch(e => {
        this.setState({ loaded: true })
      })
  }
  render() {
    let { logo, channel, loaded } = this.state
    return (
      <div className="pg-header">
        <span className="logo">
          <span className={channel ? "channel-logo" : "logo-wrap"}>
            <img
              src={loaded ? logo : null}
              alt="wayz"
              style={{ visibility: loaded ? "visible" : "hidden" }}
            />
            {channel && loaded ? <span>POWERED BY WAYZ.AI</span> : null}
          </span>
          <span className="logo-name">商业地理分析</span>
        </span>
        <div className="head-right">
          <ul className="top-links">
            {/* <li>
              <a href={PRODUCT_URL}>产品中心</a>
            </li> */}
            <li>
              <span>
                <Icon type="user" />
              </span>
              <span>{Env.getUser().user_name}</span>
              <span>
                <Icon type="down" />
              </span>
              <ul className="ls-hiden">
                <li>
                  <span
                    onClick={() => {
                      Env.logout()
                    }}
                  >
                    <Icon type="logout" />
                    <span>退出</span>
                  </span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default Header
